/**
 * The arguments that key the cached `institutionPageCombined` list: every one the
 * query passes except the page arguments (`after`, `first`), so each institution,
 * filter, sort and search keeps its own list.
 *
 * `@curbside-health-inc/client` registers the field with a keyless
 * `relayStylePagination()`, so they all share one: a "load more" that lands after a
 * filter change is appended to the new filter's results and overwrites its
 * `totalCount` and cursor. `App.tsx` replaces that policy with one keyed by this
 * list, and `__tests__/institutionPageKeyArgs.spec.ts` checks it against the query.
 */
export const INSTITUTION_PAGE_KEY_ARGS = [
  'institutionId',
  'search',
  'sortBy',
  'sortDirection',
  'labelIds',
  'labelGroupIds',
  'specialtyIds',
  'contentType',
  'categories',
  'creditedAuthors',
  'uncreditedAuthors',
  'contentStatusFilter',
  'personalFilter',
  'searchType',
  'allInstitutionSearch',
  'includeCalculators',
]
